import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Button } from "@mui/material";
import StaticPageLayout from "../../components/StaticPageLayout";
import * as styles from "./styles";

type TranslateFnT = (key: string, options?: Record<string, unknown>) => string;

const ADP_URL =
  "https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=643fec1c-5e5e-42f0-8edb-03a82d42a589&ccId=19000101_000001&lang=en_US";

type CareersContentPropsT = {
  t: TranslateFnT;
};

const CareersContent = ({ t }: CareersContentPropsT) => (
  <Box sx={styles.heroSection}>
    <Box sx={styles.heroOverlay} />
    <Box sx={styles.heroRadialOverlay} />
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
      <Box sx={styles.contentWrapper}>
        <Typography component="p" sx={styles.eyebrow}>
          {t("hero.eyebrow")}
        </Typography>

        <Typography variant="h1" sx={styles.heroTitle}>
          {t("hero.headlineBase")}{" "}
          <Box component="span" sx={styles.gradientSpan}>
            {t("hero.headlineGradient")}
          </Box>
        </Typography>

        <Typography sx={styles.subtitle}>{t("hero.subtitle")}</Typography>

        <Button href={ADP_URL} target="_blank" rel="noopener noreferrer" sx={styles.ctaButton}>
          {t("hero.ctaLabel")}
        </Button>
      </Box>
    </Container>
  </Box>
);

const CareersPage = () => {
  const { t } = useTranslation("static_careers");
  return (
    <StaticPageLayout
      title={t("meta.title")}
      description={t("meta.description")}
      canonicalUrl="https://powur.com/careers"
      noTopSpacer
    >
      <CareersContent t={t} />
    </StaticPageLayout>
  );
};

export default CareersPage;
